import React from 'react';

// Minimal inline SVG icons used only on the Payment Method page.
// Kept here to avoid a new dependency; sized via parent font-size / explicit width/height.

export const RefreshIcon: React.FC<{ size?: number; color?: string }> = ({ size = 16, color = '#fff' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M20 11.5A8 8 0 1 1 12 4a8 8 0 0 1 6.2 2.95"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M20 4v4h-4" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const InfoIcon: React.FC<{ size?: number; color?: string }> = ({ size = 18, color = '#6B7280' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="9" stroke={color} strokeWidth="1.5" />
    <path d="M12 8h.01" stroke={color} strokeWidth="2" strokeLinecap="round" />
    <path d="M11 12h1v5h1" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ShieldCheckIcon: React.FC<{ size?: number; color?: string }> = ({ size = 16, color = '#1AB394' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M12 22c-.26 0-.52-.05-.76-.15C7.42 20.32 4 16.6 4 12V6.5c0-.42.26-.8.66-.94l7-2.5a1 1 0 0 1 .68 0l7 2.5c.4.14.66.52.66.94V12c0 4.6-3.42 8.32-7.24 9.85-.24.1-.5.15-.76.15z"
      fill={color}
      fillOpacity="0.25"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M9 12.5l2 2 4-4"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LightningIcon: React.FC<{ size?: number; color?: string }> = ({ size = 16, color = '#6D5FD8' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M13 2 4 14h7l-1 8 9-12h-7l1-8z"
      fill={color}
      stroke={color}
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
  </svg>
);
